export const CHARACTER_IMAGE_EXTENSIONS = [".webp", ".jpg", ".jpeg", ".png"] as const;

export interface CharacterImageRef {
  id: string;
  displayName: string;
}

export function characterImageStem(
  characterId: string,
  appearanceId?: string,
): string {
  if (appearanceId === undefined) {
    return characterId;
  }
  return `${characterId}--${appearanceId}`;
}

export function characterImageFileNames(
  characterId: string,
  appearanceId?: string,
): string[] {
  const stem = characterImageStem(characterId, appearanceId);
  return CHARACTER_IMAGE_EXTENSIONS.map((ext) => `${stem}${ext}`);
}

export function matchingImageFile(
  names: readonly string[],
  characterId: string,
  appearanceId?: string,
): string | undefined {
  const wanted = new Set(characterImageFileNames(characterId, appearanceId));
  return names.find((name) => wanted.has(name));
}

export function characterImagePublicUrl(bookId: string, fileName: string): string {
  return `/book-data/${bookId}/characters/${fileName}`;
}

export function charactersMissingImages(
  characters: CharacterImageRef[],
  imageFileNames: readonly string[],
  minorIds: ReadonlySet<string> = new Set(),
  /** When set, only characters who have been on stage are required. */
  onStageIds?: ReadonlySet<string>,
): CharacterImageRef[] {
  const withImage = new Set(
    imageFileNames.map((name) => name.replace(/\.[^.]+$/, "")),
  );
  return characters.filter((character) => {
    if (minorIds.has(character.id) || withImage.has(character.id)) {
      return false;
    }
    if (onStageIds !== undefined && !onStageIds.has(character.id)) {
      return false;
    }
    return true;
  });
}
